export const SLICING_WASTAGE_LIST_REQUEST = "SLICING_WASTAGE_LIST_REQUEST";
export const SLICING_WASTAGE_LIST_SUCCESS = "SLICING_WASTAGE_LIST_SUCCESS";
export const SLICING_WASTAGE_LIST_FAILED = "SLICING_WASTAGE_LIST_FAILED";
